

export default class {
    constructor(el) {
        this.el = el;
        this.map = null;
        this.markers = {};
        this.infoWindows = {};
        this.timeout = null;
        this.geocoder = null;
        this.options = {
            center: {lat: -34.397, lng: 150.644},
            zoom: 5
        };
        this.init();
    }
    init() {
        this.map = new google.maps.Map(this.el, this.options);
        this.locations().forEach((location, i)=>{
            this.addLocation(location, i);
        });
    }
    addLocation(location, i) {
        let lat = location.location.location_lat,
            lng = location.location.location_lng,
            latLng = new google.maps.LatLng(lat, lng),
            marker = new google.maps.Marker({
                position: latLng,
                map: this.map,
                title: location.title,
                icon: this.pinSymbol('#2774aa')
            }),
            infoWindow = new google.maps.InfoWindow({
                content: location.content,
            });
        this.markers[location.id] = marker;
        this.infoWindows[location.id] = infoWindow;
        google.maps.event.addListener(marker, 'click', ()=>{
            infoWindow.open(this.map, marker);
        });
    }
    pinSymbol(color) {
        return {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#fff',
            strokeWeight: 2,
            scale: 1
        };
    }
    locations() {
        return [
            {
                id: 1,
                title: 'Melbourne branch',
                location: {
                    location_lat: -37.816000,
                    location_lng: 144.962310,
                },
                content: 'Level 35\n' +
                '360 Collins Street\n' +
                'Melbourne VIC 3000',
            },
            {
                id: 2,
                title: 'Sydney branch',
                location: {
                    location_lat: -33.864979,
                    location_lng: 151.204483,
                },
                content: 'Level 14\n' +
                '55 Clarence Street\n' +
                'Sydney NSW 2000',
            },
            {
                id: 3,
                title: 'Brisbane branch',
                location: {
                    location_lat: -27.466360,
                    location_lng: 153.028470,
                },
                content: 'Level 14\n' +
                '127 Creek Street\n' +
                'Brisbane QLD 4000',
            },
            {
                id: 4,
                title: 'Canberra branch',
                location: {
                    location_lat: -35.280810,
                    location_lng: 149.134030,
                },
                content: 'Level 9\n' +
                '224 Bunda Street\n' +
                'Canberra ACT 2601',
            },
        ]
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/GoogleMultiMap.js